import { render, staticRenderFns } from "./custom-modal-component.vue?vue&type=template&id=169dbe0f&scoped=true"
import script from "./custom-modal-component.vue?vue&type=script&lang=js"
export * from "./custom-modal-component.vue?vue&type=script&lang=js"
import style0 from "./custom-modal-component.vue?vue&type=style&index=0&id=169dbe0f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!./node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169dbe0f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/frontend_src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('169dbe0f')) {
      api.createRecord('169dbe0f', component.options)
    } else {
      api.reload('169dbe0f', component.options)
    }
    module.hot.accept("./custom-modal-component.vue?vue&type=template&id=169dbe0f&scoped=true", function () {
      api.rerender('169dbe0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "custom-modal-component.vue"
export default component.exports